
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms/[slug]",
      function () {
        return require("private-next-pages/forms/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms/[slug]"])
      });
    }
  